module.exports = __webpack_public_path__ + "img/clock_historial.ae04c3b6.svg";